import { NodeInterface } from "@swivl-mono/types";

export interface TabNodeLayoutInterface {
  node: NodeInterface;
  tabs: TabNodeLayoutTabInterface[];
  hideInput?: boolean;
  label?: string;
  title?: string;
  body?: string;
  imageURL?: string;
  baseWidth?: number;
  bodyHeight?: number;
  tabTitleHeight?: number;
  titleHeight?: number;
}

export interface TabNodePositionalData {
  id: string;
  type: string;
  left: number;
  top: number;
  h: string;
  w: string;
}

export interface TabNodeLayoutTabInterface {
  id: string;
  source: string;
  target?: string;
  title?: string;
  imageURL?: string;
}

export interface TabNodeDataInterface {
  [x: string | number | symbol]: unknown;
  layout: {
    path: string;
    width: number;
    height: number;
    tabs?: TabNodeLayoutTabInterface[];
    sources: string[];

    contentHeight: number;
    label?: string;
    title?: string;
    body?: any;
    bodyHeight: number;
    imageURL?: string;

    hideInput?: boolean;

    tabWidth: number;
    tabHeight: number;

    titleHeight: number;
  };
}

export const TabbedNodeDefaults = {
  contentBaseHeight: 5,
  inputHeight: 25,
  noInputHeight: 15,
  imageHeight: 150,
  labelHeight: 20,
  titleHeight: 20,
  defaultBodyHeight: 20,
  tabMargin: 10,
  tabTitleHeight: 20,
  tabPortHeight: 30,
  tabImageHeight: 60
};
type TabNodeLayoutDataOutput = { node: TabNodeDataInterface; edges: any[] };

function TabNodeLayoutData(data: TabNodeLayoutInterface): TabNodeLayoutDataOutput {
  const numberOfTabs = data.tabs ? data.tabs.length : 0;
  let tabsHaveImage = false,
    tabsHaveTitle = false;
  data.tabs.forEach((tab) => {
    if (tab.imageURL) {
      tabsHaveImage = true;
    }
    if (tab.title) {
      tabsHaveTitle = true;
    }
  });

  let tabHeight = TabbedNodeDefaults.tabPortHeight;
  if (tabsHaveImage) {
    tabHeight += TabbedNodeDefaults.tabImageHeight;
  }
  if (tabsHaveTitle) {
    tabHeight += data.tabTitleHeight ? data.tabTitleHeight : TabbedNodeDefaults.tabTitleHeight;
  }

  const tabMargin = TabbedNodeDefaults.tabMargin;

  const baseWidth = data.baseWidth || 100;

  const bodyHeight = data.bodyHeight || (data.body ? TabbedNodeDefaults.defaultBodyHeight : 0);
  let contentHeight = TabbedNodeDefaults.contentBaseHeight;

  if (!data.hideInput) {
    contentHeight += TabbedNodeDefaults.inputHeight;
  } else {
    contentHeight += TabbedNodeDefaults.noInputHeight;
  }

  if (data.label) {
    contentHeight += TabbedNodeDefaults.labelHeight;
  }
  if (data.title) {
    contentHeight += data.titleHeight || TabbedNodeDefaults.titleHeight;
  }
  if (data.imageURL) {
    contentHeight += TabbedNodeDefaults.imageHeight;
  }

  if (bodyHeight) {
    contentHeight += bodyHeight;
  }

  var width = numberOfTabs < 2 ? baseWidth : baseWidth + (baseWidth + 10) * (numberOfTabs - 1);

  var path = "M 5 " + (contentHeight + 5);
  path += " L 5 10 ";
  path += " Q 5 5 10 5";
  path += " L " + width + " 5";
  path += " Q " + (width + 5) + " 5 " + (width + 5) + " 10";
  path += " L " + (width + 5) + " " + (contentHeight + 5);

  var currentX = width + 5;
  for (var i = numberOfTabs; i > 0; i--) {
    path += " L " + currentX + " " + (contentHeight + tabHeight);
    path += " Q " + currentX + " " + (contentHeight + tabHeight + 5) + " " + (currentX - 5) + " " + (contentHeight + tabHeight + 5);
    path += " L " + (currentX - baseWidth + 5) + " " + (contentHeight + tabHeight + 5);
    path += " Q " + (currentX - baseWidth) + " " + (contentHeight + tabHeight + 5) + " " + (currentX - baseWidth) + " " + (contentHeight + tabHeight);

    if (i !== 1) {
      // IF NOT LAST TAB
      path += " L " + (currentX - baseWidth) + " " + (contentHeight + 5 + tabMargin);
      currentX = currentX - baseWidth - 10;
      path += " L " + currentX + " " + (contentHeight + 5 + tabMargin);
    }
  }
  path += " z";

  let tabs: TabNodeLayoutTabInterface[] | undefined = data.tabs
    ? data.tabs.map((t) => ({
        id: t.id,
        source: t.source,
        target: t.target,
        title: t.title,
        imageURL: t.imageURL
      }))
    : undefined;

  var edges: any[] = [];
  var sources: string[] = [];
  if (data.tabs) {
    data.tabs.forEach((t) => {
      const source = data.node.id + "." + t.source;
      sources.push(source);

      if (t.target) {
        edges.push({
          source: source,
          target: t.target,
          label: t.title
        });
      }
    });
  }

  const height = contentHeight + tabHeight + 5;

  let output: TabNodeLayoutDataOutput = {
    node: {
      ...data.node,
      layout: {
        path: path,
        width: width,
        height: height,
        tabs: tabs,
        sources: sources,
        contentHeight: contentHeight,
        label: data.label,
        title: data.title,
        body: data.body,
        bodyHeight: bodyHeight,
        imageURL: data.imageURL,
        tabWidth: baseWidth,
        tabHeight: tabHeight,
        titleHeight: data.titleHeight || TabbedNodeDefaults.titleHeight
      }
    },
    edges: edges
  };
  if (data.hideInput) {
    output.node.layout.hideInput = true;
  }
  return output;
}

// const TabNodeLayoutData = function(layoutData:TabNodeLayoutInterface):TabNodeDataInterface {
//   const baseWidth = (layoutData.baseWidth)? layoutData.baseWidth : 100;

//   const hasInput = (hideInput) ? false : true;
//     /*
//     Tab Date is:
//     {id:String, target: String of target node or null, title:title to show for the tab}
//      */

//     /*
//     Tab Example
//     {
//        "id":  "buttons_" + condition.id,
//        "source": node.id + ".conditions_" + condition.id + "_conditionMetGoto",
//        "target": condition.conditionMetGoto + ".target",
//        "title": "Some Title"
//      }
//      */

//       var data = {node:{
//                           id:node.id,
//                           type:node.type,
//                           left:node.left,
//                           top:node.top,
//                           layout:{}
//                         },
//                        edges:[]};

//         data.node.layout.headerText = heading;
//         data.node.layout.titleText = title;
//         data.node.layout.bodyText = bodyText;

//       const pathData = dataForTabbedNode(baseWidth, tabs.length, hasInput, true, false);
//       data.node.layout = pathData;
//       data.node.layout.tabs = [];

//       for (var i = 0; i < tabs.length; i++) {
//         let hasTarget = (tabs[i].target && tabs[i].target.length > 0 && nodes &&  nodes[tabs[i].target])
//         data.node.layout.tabs.push( { portId:tabs[i].source,
//                                       id: node.id + "_tab_" + tabs[i].id ,
//                                       text:tabs[i].title,
//                                       dotClass:(hasTarget)? "bottomConnected":"",
//                                       width:pathData.tabWidth,
//                                       height:pathData.tabHeight,
//                                       left:((pathData.tabWidth + 10 ) * i) + 5})

//         if (hasTarget) { // Add Edges
//           data.edges.push(  {
//                "id":  tabs[i].id,
//                "source": node.id + "." + tabs[i].source,
//                "target": tabs[i].target
//              })
//         }

//       }

//       return data;

//     }
export default TabNodeLayoutData;
